import React from 'react';
import { ArcButton } from '@src/core/ui';
import { useNavigate } from 'react-router-dom';
import { ModifyMissionOrderButtonProps } from './types';
import { routesConfig } from '@src/core/routes';

const ModifyMissionOrderButton: React.FC<ModifyMissionOrderButtonProps> = (props) => {
  const { missionId } = props;
  const navigate = useNavigate();  
  
  if (!missionId) return null;
    
  return (
    <ArcButton.brand fullWidth onClick={() => navigate(`${routesConfig.orders}/update-mission/${missionId}`)}> 
      Modify 
    </ArcButton.brand>
  );
};

export default ModifyMissionOrderButton;